// Replacement for @opengov/app-core/locale/loader.js for Vite builds.
//
// The original (in node_modules/@opengov/app-core/locale/loader.js) uses a
// dynamic `import()` of a JSON file with two interpolated path segments:
//
//   import(`./${namespace}.${locale}.locale.json`)
//
// Webpack resolved this at build time via its dynamic-import scanner +
// `webpackChunkName` magic comment, emitting one JS chunk per locale to
// build/assets/. Vite's static analysis can't pre-resolve a two-segment
// template, so it falls back to a runtime URL fetch which the browser then
// rejects as "module script but MIME application/json".
//
// We bypass dynamic import entirely and `fetch()` the JSON. The post-build
// `cp` step in package.json puts the JSON files at /stories/assets/, so the
// asset URL we build here resolves to a real file at runtime.
//
// `import.meta.env.BASE_URL` is Vite's authoritative base prefix (`/stories/`
// for dev/local builds, the CloudFront URL for deployed builds). Using it
// keeps this shim correct across all modes without hardcoding.

import { localeLoaderMiddleware } from '@opengov/locale/loader';

const NAMESPACE = 'appCore';

export const localeLoader = async (namespace, locale) => {
  const base = import.meta.env.BASE_URL || '/';
  const url = `${base.replace(/\/$/, '')}/assets/${namespace}.${locale}.locale.json`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load locale ${namespace}/${locale} from ${url}: ${response.status}`);
  }
  return response.json();
};

export const localeMiddleware = localeLoaderMiddleware(NAMESPACE, localeLoader);
